module.exports = __webpack_public_path__ + "img/Bénin-cité-lacustre.1a609e24.jpeg";